(function () {
  'use strict';

  if (window.__micushDrawerInitialized) return;
  window.__micushDrawerInitialized = true;

  var overlay, drawer, closeBtn, btn;
  var lastFocus = null;
  var isOpen = false;

  function buildDrawer() {
    overlay = document.createElement('div');
    overlay.id = 'micush-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    drawer = document.createElement('div');
    drawer.id = 'micush-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'תפריט ניווט');
    drawer.setAttribute('tabindex', '-1');

    var drawerHeader = document.createElement('div');
    drawerHeader.id = 'micush-drawer-header';

    closeBtn = document.createElement('button');
    closeBtn.id = 'micush-close';
    closeBtn.setAttribute('aria-label', 'סגור תפריט');
    closeBtn.textContent = '✕';

    var title = document.createElement('span');
    title.id = 'micush-drawer-title';
    title.textContent = 'תפריט';

    drawerHeader.appendChild(closeBtn);
    drawerHeader.appendChild(title);

    var nav = document.createElement('nav');
    nav.id = 'micush-nav';
    var ul = buildNavList(window.__micushLinks || [], 0);
    nav.appendChild(ul);

    drawer.appendChild(drawerHeader);
    drawer.appendChild(nav);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    closeBtn.addEventListener('click', requestClose);
    overlay.addEventListener('click', requestClose);

    drawer.addEventListener('keydown', function(e) {
      trapFocus(drawer, e);
      if (e.key === 'Escape') requestClose();
    });

    drawer.addEventListener('click', function(e) {
      if (e.target.tagName === 'A') requestClose();
    });
  }

  function buildNavList(links, depth) {
    var ul = document.createElement('ul');
    ul.className = 'micush-level micush-level--' + depth;
    for (var i = 0; i < links.length; i++) {
      ul.appendChild(buildItem(links[i], depth));
    }
    return ul;
  }

  function buildItem(link, depth) {
    var li = document.createElement('li');
    li.className = 'micush-item micush-item--' + depth;

    var hasChildren = link.children && link.children.length > 0;

    if (hasChildren) {
      var btnEl = document.createElement('button');
      btnEl.setAttribute('aria-expanded', 'false');

      var toggle = document.createElement('span');
      toggle.className = 'micush-toggle';
      toggle.textContent = '+';
      toggle.setAttribute('aria-hidden', 'true');

      var label = document.createElement('span');
      label.className = 'micush-label';
      label.textContent = link.title;

      btnEl.appendChild(toggle);
      btnEl.appendChild(label);

      btnEl.addEventListener('click', (function(t, tog) {
        return function() {
          var expanded = li.classList.toggle('is-expanded');
          t.setAttribute('aria-expanded', String(expanded));
          tog.textContent = expanded ? '−' : '+';
        };
      })(btnEl, toggle));

      var subUl = buildNavList(link.children, depth + 1);
      subUl.classList.add('micush-submenu');

      li.appendChild(btnEl);
      li.appendChild(subUl);
    } else {
      var a = document.createElement('a');
      a.href = link.url;
      a.textContent = link.title;
      li.appendChild(a);
    }
    return li;
  }

  function findWrapper() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) return null;
    var headerDrawerEl = details.closest('header-drawer');
    if (!headerDrawerEl) return null;
    return headerDrawerEl.parentElement; /* .header__drawer */
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    if (btn) {
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.classList.add('micush-no-scroll');
    setTimeout(function() { drawer.focus(); }, 50);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    if (btn) {
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.classList.remove('micush-no-scroll');
    if (lastFocus) lastFocus.focus();
  }

  function requestClose() {
    closeDrawer();
  }

  function trapFocus(drawerEl, e) {
    var focusable = drawerEl.querySelectorAll('a[href], button:not([disabled])');
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }

  /* ── Insert (or re-insert) our own hamburger button ─────────
     Shopify's section-hydration script can replace the header
     section's HTML shortly after page load (to inject
     personalized data like cart/account state), which wipes out
     any DOM node we added inside that section — including our
     button. So instead of inserting once, we continuously watch
     for its disappearance and re-add it whenever needed. ────── */
  function ensureButton() {
    if (document.getElementById('micush-hamburger-btn')) return; /* still there */

    var wrapperDiv = findWrapper();
    if (!wrapperDiv) return;

    btn = document.createElement('button');
    btn.id = 'micush-hamburger-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'פתח תפריט');
    btn.setAttribute('aria-controls', 'micush-drawer');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) btn.classList.add('is-open');

    var iconWrap = document.createElement('span');
    iconWrap.className = 'micush-hamburger-icon';
    iconWrap.innerHTML = '<span></span><span></span><span></span>';
    btn.appendChild(iconWrap);

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    wrapperDiv.appendChild(btn);
  }

  function watchForReplacement() {
    var observer = new MutationObserver(function() {
      ensureButton();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    buildDrawer();
    ensureButton();
    watchForReplacement();

    /* Also re-check a few times shortly after load, in case
       hydration happens on a timer rather than triggering a
       MutationObserver-visible change immediately. */
    setTimeout(ensureButton, 300);
    setTimeout(ensureButton, 1000);
    setTimeout(ensureButton, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
